
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SystemAttributes } from '../../modal/attributes.model';
import { KanbanState } from '../../../../kanban.model';
import CellStore from '../../../../../../stores/CellStore';
import Spinner from '../../../../../util/Spinner';
import { Board } from '../../../../../backend/backendapi';
import { isBoardNotInSelectedAccount } from '../../../../kanban.util';

@Component({
  components: { Spinner },
})
export default class CellAttribute extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly attributes!: SystemAttributes;

  readonly store = new CellStore();

  get cellPath(): string {
    return this.store.cellsForVSelect.find(e => e.id === this.attributes.cellId)?.name ?? '';
  }

  get isBoardNotInSelectedAccount(): boolean {
    return isBoardNotInSelectedAccount(this.board, this.state.accounts);
  }

  mounted(): void {
    this.store.loadIfAbsent();
  }

  @Watch('state.accounts')
  private onAccountChanged(): void {
    this.store.reload();
  }
}
